/**
 * Bridge between request error handling and the read-only dialog.
 *
 * EnforceReadOnly answers 403 { code: 'read_only' }. The API client and the
 * Inertia error hook call openReadOnlyDialog(); the dialog in
 * features/read-only-access registers itself on mount. Kept in shared/api so
 * that shared code never imports a feature (same pattern as ./secondFactor).
 */

export const READ_ONLY_CODE = 'read_only';

let handler: ((action?: string) => void) | null = null;

export function isReadOnlyDenial(status: number, payload: unknown): boolean {
    return status === 403 && typeof payload === 'object' && payload !== null && (payload as { code?: unknown }).code === READ_ONLY_CODE;
}

/** Register the dialog opener. Returns an unregister function. */
export function setReadOnlyHandler(next: (action?: string) => void): () => void {
    handler = next;
    return () => {
        if (handler === next) handler = null;
    };
}

/**
 * Open the dialog. `action` names the forbidden action when the caller knows
 * it (design D4: «Генерація ключів недоступна»); server 403s pass nothing.
 * Returns false when no dialog is mounted.
 */
export function openReadOnlyDialog(action?: string): boolean {
    if (!handler) return false;
    handler(action);
    return true;
}
